module.exports = __webpack_public_path__ + "img/Bitmap 1.e93a7829.png";